module.exports = __webpack_public_path__ + "static/img/text1.41402aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/text1.png
// module id = F06D
// module chunks = 1